import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";

import { fetchClassAction } from "../../actions/fetchClass";

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 500,
    height: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

export default function ClassPickerList(props) {
  const [singleClass, setSingleClass] = useState({})

  const { classroom } = props;

  const { handlePick } = props 
  const { setPage } = props
  
  useEffect(() => {
    if (typeof classroom === 'string') {
      fetchClassAction(classroom, setSingleClass)
    } else {
      setSingleClass(classroom)
    }
  }, [classroom]);

  const handleClick = (event) => {
    handlePick(singleClass._id)
  }

  if (singleClass !== null && typeof singleClass !== "undefined") {
    return (
      <Button variant="h6" onClick={handleClick} sx={{}}>{singleClass.name}</Button>
    )
  } else {
    return <></>
  }
}